import React, { useRef } from 'react';

import ScrollTopButton from '../../../../shared/ReviewDEV/ReviewContent/ScrollTopButton/ScrollTopButton';

import ItemGroup from './ItemGroup/ItemGroup';
import LastPlaceholder from './LastPlaceholder';

import './Container.scss';

export default function Container({ logs, updateItemInAllLogs, contentRefContainer, activeScrollId }) {
  const containerHeight = contentRefContainer?.current?.offsetHeight;
  const lastElementRef = useRef(null);
  const lastElementHeight = lastElementRef.current?.offsetHeight;

  return (
    <div className="val-container" ref={contentRefContainer}>
      {logs?.map(function(log, index) {
        if (log.status !== 'PENDING') {
          const isLastElement = index === logs.length - 1;
          return (
            <ItemGroup
              key={log.itemGroupTemplateId}
              log={log}
              updateItemInAllLogs={updateItemInAllLogs}
              lastElementRef={isLastElement ? lastElementRef : null}
              isActiveElement={activeScrollId === log.itemGroupTemplateId}
            />
          );
        }
        return null;
      })}
      <LastPlaceholder lastElementHeight={lastElementHeight} containerHeight={containerHeight} />
      <ScrollTopButton container={contentRefContainer?.current} />
    </div>
  );
}
